import { IS_QUIZ } from "../actions/actionTypes";
const initialState = {
  isQuiz: false,
};

export default function (state = initialState, action) {
  //  (action.payload);
  switch (action.type) {
    case IS_QUIZ:
      return {
        ...state,
        isQuiz: action.payload,
      };

    default:
      return state;
  }
}
